import { get, post, remove } from '@/services/BaseService'

class DALLEService {
    findAll(params, callback) {
        const requestParams = {
            ...params,
            includes: ['dalleImageResults']
        }
        return get('integrations/openai/dalle/images', requestParams)
            .then(response => {
                const data = response.data || {}
                const rows = Array.isArray(data.rows) ? data.rows : []
                const total = data.total || 0

                const transformedData = {
                    rows: rows.map(item => {
                        const imageResults = Array.isArray(item.dalleImageResults) ? item.dalleImageResults : []
                        return {
                            ...item,
                            dalleImageResults: imageResults
                        }
                    }),
                    total: total
                }
                callback && callback({ data: transformedData })
                return transformedData
            })
            .catch(error => {
                callback && callback({ data: { rows: [], total: 0 } })
                return { rows: [], total: 0 }
            })
    }

    generate(params, callback) {
        return post('integrations/openai/dalle/images/generate', params)
            .then(response => {
                const data = response.data || {}
                if (data) {
                    data.dalleImageResults = data.dalleImageResults || []
                }
                callback && callback({ data })
                return data
            })
    }

    remove(id, callback) {
        return remove(`integrations/openai/dalle/images/${id}`)
            .then(response => {
                callback && callback(response)
                return response
            })
    }

    find(id, callback) {
        return get(`integrations/openai/dalle/images/${id}`, { includes: ['dalleImageResults'] })
            .then(response => {
                const data = response.data || {}
                if (data) {
                    data.dalleImageResults = data.dalleImageResults || []
                }
                callback && callback({ data })
                return data
            })
    }
}

export default new DALLEService()
